// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1xKQr","modalForm":"UpgradeEpcsModal_modalForm__t2xXK","modalFooter":"UpgradeEpcsModal_modalFooter__3BXSe"};